import { services } from "../../services";
import { getAllEventData } from "./getAllEventData";

export const captureEvent = async (eventData: any, ip: any) => {
  let userData = {
    userId: "",
    category: "",
    subcategory: "",
    name: "",
    sessionId: "",
    anonymousId: "",
    locationData: {},
    ...eventData,
  };

  const body = getAllEventData(userData, ip);

  try {
    const data = await services.analyticsService.captureEvent(body);
    console.log("capture", data);
  } catch (e) {
    console.log("error", e);
  }
};
